'use strict';

var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');
var Modal = require('./modal');
var Pace = require('./pace');

var notifyMe = '#notifyMe';
var productDetail = $('.js-product-detail').data('layer') || {};

var NotifyMe = {
  open: function open(event) {
    event && event.preventDefault();

    if (!/products/.test(blz.pageName) && $(this).data('url')) {
      return (location.href = $(this).data('url') + '?notifyMe');
    }

    Modal.open({
      title: 'Avise-me Quando Chegar',
      body: (document.querySelector(notifyMe) || {}).outerHTML || '',
      windowTopClass: 'small-modal',
      onOpen: function ($modal) {
        if (blz.me) {
          var name =
            blz.me.givenName || blz.me.familyName
              ? (blz.me.givenName || '') + ' ' + (blz.me.familyName || '')
              : '';
          var mail = blz.me.email || '';
          $modal.querySelector('input[name="givenName"]').value = name;
          $modal.querySelector('input[name="email"]').value = mail;
        }
      }
    });
  },

  notify: function notify(event) {
    event && event.preventDefault();

    var data = {
      name: (this.querySelector('.notify-name') || {}).value,
      email: (this.querySelector('.notify-email') || {}).value
    };

    if (!data.name || !data.email) {
      return NotificationService.warning('all_fields_required');
    }

    Pace.open();

    HTTPService.post('/api/notifications/product/notify-me', { data: data, sku: productDetail.id })
      .then(HTTPService.handleClientError)
      .then(function () {
        NotificationService.success('E-mail cadastrado com sucesso!');
        Modal.close();
      })
      .catch(NotificationService.warning)
      .always(Pace.close);
  },

  openLink: function openLink(event) {
    var data = $(this).data();

    if (data.webview && (window.Native || {}).notifyMe) {
      event.preventDefault();
      window.Native.notifyMe((data.sku || [])[0], data.slugname);
    }
  }
};

$('.js-notify-me').on('click tap', NotifyMe.open);
$('body').on('click tap', '.js-notify-me-link', NotifyMe.openLink);
$('body').on('submit', notifyMe + ' form', NotifyMe.notify);

if (/notifyMe/.test(window.location.href) && /products/.test(blz.pageName)) {
  // using timeout to prevent bootstrap modal bug
  setTimeout(NotifyMe.open, 100);
}

module.exports = NotifyMe;
